var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCandadoBlanco = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9.333,
    viewBox: "0 0 7 9.333",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "candado",
    d: "M9.125,3.5H8.833V2.333a2.333,2.333,0,1,0-4.667,0V3.5H3.875A.876.876,0,0,0,3,4.375V8.458a.876.876,0,0,0,.875.875h5.25A.876.876,0,0,0,10,8.458V4.375A.876.876,0,0,0,9.125,3.5ZM4.944,2.333a1.556,1.556,0,1,1,3.111,0V3.5H4.944ZM6.889,6.5v.886a.389.389,0,1,1-.778,0V6.5a.778.778,0,1,1,.778,0Z",
    transform: "translate(-3)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCandadoBlanco, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/candado_blanco.97c17bb7.svg";
export { ForwardRef as ReactComponent };